var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"donut-chart-label"},[_c('i',{staticClass:"square mr-2",style:({'background-color': `${_vm.color}`})}),_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.$t(_vm.label)))]),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.value)+" "+_vm._s(_vm.unit))])])
}
var staticRenderFns = []

export { render, staticRenderFns }